import React from 'react';
import { Award, Clock, Shield, DollarSign, Wrench, Star } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription } from './ui/card';
import { whyChooseUs } from '../data/mock';

const About = () => {
  const iconMap = {
    'Award': Award,
    'Clock': Clock,
    'Shield': Shield,
    'DollarSign': DollarSign,
    'Wrench': Wrench,
    'Star': Star
  };

  const icons = [Award, Clock, Shield, DollarSign, Wrench, Star];

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose 306 Garage Doors?
          </h2>
          <p className="text-xl text-gray-600">
            We're not just another garage door company - we're your trusted local experts with a proven track record of excellence.
          </p>
        </div>

        {/* Features grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {whyChooseUs.map((item, index) => {
            const IconComponent = icons[index % icons.length];
            return (
              <Card 
                key={index}
                className="border-2 hover:border-blue-800 hover:shadow-xl transition-all duration-300"
              >
                <CardHeader>
                  <div className="flex items-center justify-center w-14 h-14 bg-green-100 rounded-xl mb-4">
                    <IconComponent size={28} className="text-green-700" />
                  </div>
                  <CardTitle className="text-xl mb-2">
                    {item.title}
                  </CardTitle>
                  <CardDescription className="text-gray-600 text-base">
                    {item.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            );
          })}
        </div>

        {/* About content */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Your Local Garage Door Specialists
            </h3>
            
            <div className="space-y-4 text-lg text-gray-700 leading-relaxed">
              <p>
                <span className="font-semibold text-blue-800">306 Garage Doors</span> is your trusted choice for homeowners and businesses throughout Saskatchewan. We've built our reputation on quality workmanship, premium products, honest pricing, and exceptional customer service.
              </p>
              
              <p>
                Whether you need a new garage door installed, an emergency repair at 3 AM, or routine maintenance to keep your door running smoothly, our team of licensed and insured professionals is here to help. We work with all major brands and use only the best quality products for every installation.
              </p>
              
              <p>
                What sets us apart is our commitment to excellence. We provide the best workmanship using premium quality garage doors and parts. We don't cut corners - we deliver superior results that last. That's why so many Saskatchewan residents trust us with their garage door needs.
              </p>

              <p className="font-semibold text-blue-800 text-xl pt-4">
                Experience quality you can trust. Call us today at 306-262-5995!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
